import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { CategoryGridNav } from './CategoryGridNav';

export const buildMenus = (flattedCategories, categoryKey, rootCategory) => {
  if (!categoryKey && rootCategory) return [rootCategory];
  if (!categoryKey) return [];
  const featuredCategory = flattedCategories.find(({ key }) => key === categoryKey);
  return [
    ...buildMenus(flattedCategories, featuredCategory.parentCategory, rootCategory),
    featuredCategory,
  ];
};

const CategoryGridHeader = ({ categoryKey, flattedCategories, description, rootCategory }) => {
  const featuredCategory = flattedCategories.find(({ key }) => key === categoryKey);
  const menus = buildMenus(flattedCategories, categoryKey, rootCategory);
  const isTopLevel = menus.length === (rootCategory ? 2 : 1);
  const isBottomLevel = !featuredCategory.children || featuredCategory.children.length === 0;

  return (
    <div className={classnames('category-grid__label-section', { isTopLevel })}>
      <CategoryGridNav menus={menus} activeCategoryKey={categoryKey} />
      <h1 className={classnames('category-grid__title', { isBottomLevel })}>
        {featuredCategory.name}
      </h1>
      {description && (
        <p
          className="category-grid__description"
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: description }}
        />
      )}
    </div>
  );
};

CategoryGridHeader.propTypes = {
  categoryKey: PropTypes.string,
  description: PropTypes.string,
  flattedCategories: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      children: PropTypes.arrayOf(PropTypes.shape({})),
      images: PropTypes.shape({}),
      key: PropTypes.string,
      name: PropTypes.string,
      parentCategory: PropTypes.string,
    })
  ),
  rootCategory: PropTypes.shape({
    key: PropTypes.string,
    name: PropTypes.string,
    url: PropTypes.string,
  }),
};

export default CategoryGridHeader;
